import {
  iconLinkedin,
  iconGoogle,
  iconMicrosoft,
  iconPluralsight,
  iconDefault,
  certIAPetronas,
  iconFigma,
  iconSketch,
  iconXd,
  iconAdobe,
  iconBlender,
  iconSpline,
  iconAe,
  iconAxure,
  iconInvision,
  iconMarvel,
  iconEx,
  iconHtml,
  iconCss,
  iconJs,
  iconReact,
  iconWp,
} from "../assets/index";
export const experienceList = [
  {
    companyName: "Seetru Studio",
    designation: "UX Researcher",
    duration: "Full Time (Contract)",
    period: "Feb 2026",
    location: "Kuala Lumpur, Malaysia",
  },
  {
    companyName: "FPT Software",
    designation: "UX Lead",
    duration: "Full Time",
    period: "Aug 2021 - Jan 2025",
    location: "Kuala Lumpur, Malaysia",
  },
  {
    companyName: "Stampede Solution - VOLARE",
    designation: "UI/UX Designer",
    duration: "Full Time",
    period: "Mar 2020 - Jul 2021",
    location: "Kuala Lumpur, Malaysia",
  },
  {
    companyName: "Siroi Solutions Sdn Bhd",
    designation: "UI/UX Designer",
    duration: "Full Time",
    period: "Aug 2018 - Mar 2020",
    location: "Kuala Lumpur, Malaysia",
  },
  {
    companyName: "Freelance",
    designation: "UI/UX Designer",
    duration: "Part Time",
    period: "Jan 2015 - Dec 2019",
    location: "Remote",
  },
  {
    companyName: "Mazik Global",
    designation: "UI Designer & Front-End Developer",
    duration: "Full Time",
    period: "Oct 2012 - Jul 2018",
    location: "Karachi, Pakistan",
  },
  {
    companyName: "Softnology Systems",
    designation: "Web Designer",
    duration: "Full Time",
    period: "Dec 2010 - Oct 2012",
    location: "Karachi, Pakistan",
  },
];

export const coreSkills = [
  "User Research & Analysis",
  "Interaction Design",
  "Visual Design",
  "Collaboration",
  "Prototype",
  "Adaptability",
  "Information Architecture",
  "Usability Testing",
  "User Interview",
  "Communication",
  "Solution Sketch",
  "Wireframe",
  "Strategic Vision",
  "Leadership",
  "Mentorship",
  "Design Systems Management",
  "Agile and Lean UX",
  "Accessibility and Inclusive Design",
  "Analytics",
  "Data-Driven Design",
  "Cross-Platform Design",
  "Stakeholder Management",
  "Heuristic Evaluation",
  "Workshop Facilitation",
  "A/B Testing",
  "User Flows",
  "Conflict Resolution",
  "Motion Design",
];

export const tools = [
  {
    name: "Figma",
    icon: iconFigma,
  },
  {
    name: "Sketch",
    icon: iconSketch,
  },
  {
    name: "Adobe XD",
    icon: iconXd,
  },
  {
    name: "Adobe",
    icon: iconAdobe,
  },
  {
    name: "Blender",
    icon: iconBlender,
  },
  {
    name: "Spline",
    icon: iconSpline,
  },
  {
    name: "After Effect",
    icon: iconAe,
  },
  {
    name: "Axure RP",
    icon: iconAxure,
  },
  {
    name: "Invision",
    icon: iconInvision,
  },
  {
    name: "Marvel",
    icon: iconMarvel,
  },
  {
    name: "ExcaliDraw",
    icon: iconEx,
  },
  {
    name: "HTML",
    icon: iconHtml,
  },
  {
    name: "CSS",
    icon: iconCss,
  },
  {
    name: "JS",
    icon: iconJs,
  },
  {
    name: "React",
    icon: iconReact,
  },
  {
    name: "Wordpress",
    icon: iconWp,
  },
];

export const certAwards = [
  {
    name: "Foundations of User Experience (UX) Design",
    organization: "Google",
    receivedYear: "2023",
    url: "https://www.coursera.org/account/accomplishments/verify/5YLXXWSMBKK7",
    logo: iconGoogle,
  },
  {
    name: "Information Architecture Foundation Course",
    organization: "Petronas Digital Sdn Bhd",
    receivedYear: "2022",
    url: certIAPetronas,
    logo: iconDefault,
  },
  {
    name: "UX Information Architecture",
    organization: "Pluralsight",
    receivedYear: "Oct 2022",
    url: "",
    logo: iconPluralsight,
  },
  {
    name: "The Art and Practice of Information Architecture",
    organization: "Pluralsight",
    receivedYear: "Sep 2022",
    url: "",
    logo: iconPluralsight,
  },
  {
    name: "Introduction to Information Architecture",
    organization: "Pluralsight",
    receivedYear: "Sep 2022",
    url: "",
    logo: iconPluralsight,
  },
  {
    name: "Design Thinking: UX and Advanced Topics",
    organization: "Microsoft DEV318x",
    receivedYear: "Jan 2020",
    url: "",
    logo: iconMicrosoft,
  },
  {
    name: "UX Design: Overview",
    organization: "LinkedIn",
    receivedYear: "Jul 2019",
    url: "",
    logo: iconLinkedin,
  },
  {
    name: "UX Design: 6 Paper PrototypingUX Design: 6 Paper Prototyping",
    organization: "LinkedIn",
    receivedYear: "Jul 2019",
    url: "",
    logo: iconLinkedin,
  },
  {
    name: "Web Development Orientation: Microsoft Professional Program",
    organization: "Microsoft - DEV237x",
    receivedYear: "Jan 2018",
    url: "",
    logo: iconMicrosoft,
  },
];
export const awards = [
  {
    name: "Go Dashboard - An Award Wining Project",
    organization:
      "Oil & Gas award at Malaysia Technology Excellence Awards 2022",
    receivedYear: "2022",
    url: "https://sbr.com.sg/co-written-partner/event-news/petronas-takes-home-information-management-oil-gas-award-malaysia-technology-excellence-awards-2022",
  },
];
